import React from 'react'
import * as Components from 'antd';

export default ({ ...rest }: any) => <Components.Form.Item {...rest} />